import fs from "fs";
import path from "path";

import { Container, Grid } from "@mui/material";
import { colors } from "common";
import BazarImage from "components/BazarImage";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import ReviewCard from "components/reviews/ReviewCard";
import { H2, H3, Paragraph } from "components/Typography";
import Link from "next/link";
import { Review } from "common/types/review";
import { Key } from "react";
import { googleReviews } from "common/constants/google-reviews";

const ReviewsPage = ({}) => {
  return (
    <ShopLayout1 title="Google Reviews" navbar={<Navbar />}>
      <Container maxWidth="lg" sx={{ p: 2 }}>
        <BazarImage
          alt="customer satisfaction reviews"
          src={
            "/assets/images/landing/pc_worth_20000_builds_1000_reviews_100_customer_satisfaction.png"
          }
          sx={{ width: "100%", mt: 2 }}
        />

        <Link
          passHref
          target="_blank"
          rel="noopener noreferrer"
          href="https://goo.gl/maps/Gixp8649japUZREf8"
        >
          <p>
            <H2 sx={{ cursor: "pointer" }} mt={1}>
              Google Reviews
              <H3 sx={{ cursor: "pointer" }} color={colors.link}>
                See Google Reviews
              </H3>
            </H2>
          </p>
        </Link>

        <Grid mt={2} container spacing={1.25}>
          {googleReviews?.map((item: Review, ind: Key) => (
            <Grid item sm={4} xs={12} key={ind}>
              <ReviewCard review={item} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </ShopLayout1>
  );
};

export default ReviewsPage;
